//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.StartInspectionMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.StartInspectionMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.StartInspectionMutationSelections
import com.wintermar.inspection.graphql.type.InspectionStatus
import com.wintermar.inspection.graphql.type.StartInspectionCommandInput
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class StartInspectionMutation(
  public val startInspectionCommandInput: StartInspectionCommandInput,
) : Mutation<StartInspectionMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    StartInspectionMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = StartInspectionMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = StartInspectionMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(StartInspectionMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val startInspection: StartInspection,
  ) : Mutation.Data

  public data class StartInspection(
    public val status: InspectionStatus,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "d30169102870b925f7dccecf5692bd9a8d851f37a214f03061d1ecb7abeb08e3"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation startInspection($startInspectionCommandInput: StartInspectionCommandInput!) {
     *   startInspection(command: $startInspectionCommandInput) {
     *     status
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation startInspection(${'$'}startInspectionCommandInput: StartInspectionCommandInput!) { startInspection(command: ${'$'}startInspectionCommandInput) { status } }"

    public const val OPERATION_NAME: String = "startInspection"
  }
}
